import React, { useState, useEffect, useRef, Fragment } from "react";

import {
  Button,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
  Row,
  Col,
  Alert
} from "reactstrap";

// core components
import AppNavbar from "components/Navbars/AppNavbar";
import SimpleFooter from "components/Footers/SimpleFooter";

const jobsExample = [
    {
        title: 'Senior Full Stack Developer',
        description: 'We are looking for a Full Stack Developer to take on our Senior Developer role at Club Apps. This position will include developing and maintaining both our back-end Laravel API and our front-end React Web Application. You will work remotely as the lead of our product development team to build and launch product updates utilizing development tools and junior developers skillsets. To apply, please follow the link below.',
        url: 'https://www.indeedjobs.com/club-apps/_hl/en_US?cpref=JXWAtnzf3XWjLOi4YeVNLqF8RN6a-VzueOhrlZfM3C4'

    }
];

export default function Index(props) {

    const [ jobs, setJobs ] = useState([]);

    const [ form, setForm ] = useState({
        first: '',
        last: '',
        email: '',
        interest: '',
    });

    const [ loading, setLoading ] = useState(false);
    const [ formSubmitted, setFormSubmitted ] = useState(false);

    const [ errors, setErrors ] = useState({});
    const [ errorMessage, setErrorMessage ] = useState(null)

    const mainEl = useRef(null);

    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        mainEl.current.scrollTop = 0;

        document.title = "Club Apps | Competitve Salaries and Plenty of Perks"
        document.querySelector('meta[name="description"]').setAttribute("content", "Club Apps promotes a fun and healthy work environment with many of our positions existing remotely and a focus on flexible work schedules, perks and competitve saleries.");
    }, []);

    const handleChange = name => event => {
        setErrorMessage(null);

        const target = event.target;
        const value = (target.type === 'checkbox' ? target.checked : target.value);

        if (isError(name)) delete errors[name];

        setForm({ ...form, [name]: value });
    };

    const postForm = e => {

        e.preventDefault();
        setErrors({});
        setErrorMessage(null);

        let newErrors = {};

        if (form.email === null || form.email === "" || ! validEmail(form.email)) {
            newErrors.email = 'Please provide a valid email address.';
        }

        if (form.first === null || form.first === "") {
            newErrors.first = 'We need your first name to properly address you.';
        }

        if (form.last === null || form.last === "") {
            newErrors.last = 'We need your last name to properly address you.';
        }

        if (form.interest === null || form.interest === "") {
            newErrors.last = 'We need to know what your interested in to help with recruiting.';
        }

        if (Object.keys(newErrors).length === 0) {
            
            setLoading(true);

            _agile.create_contact({email: form.email}, {
                success: postContactDetails,
                error: postContactDetails
            });
            
        } else {
            setErrors(newErrors);
            setErrorMessage("Looks like you missed some required fields.");
        }
    }

    const postContactDetails = () => {
        _agile.set_email(form.email);

        _agile.update_contact({ 
            first_name: form.first,
            last_name: form.last,
            interest: form.interest
        });
        
        _agile.add_tag('Recruiting, Newsletter', {
            success: () => {
                setLoading(false);
                setFormSubmitted(true);
            },
            error: () => {
                setLoading(false);
                setErrorMessage("Looks like we have experienced an error. Please try again later or email us at jobs@clubapps.org.");
            }
        });
    }

    const validEmail = email => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    const isError = field => {
        if (errors[field]) return true;
        return false;
    }

    return (
        <Fragment>
            <AppNavbar white/>
            <main ref={mainEl}>
                <section className="section section-xl section-shaped pb-200">
                    <div className="jobs-background-container"/>
                    <Container className="py-lg-md d-flex">
                        <div className="col px-0">
                            <Row>
                                <Col md="6">
                                    <h1 className="display-3">
                                        Jobs
                                    </h1>
                                    <p className="lead">
                                        Club Apps promotes a fun and healthy work environment with many of our positions existing remotely and a focus on flexible work schedules. Check out our available positions below and if you see something that could fit, fill out the form and we will get in touch.
                                    </p>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                    <div className="separator separator-bottom separator-skew">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                            >
                            <polygon
                                className="fill-secondary"
                                points="0 0 2560 100 0 100"
                                />
                        </svg>
                    </div>
                </section>
                <section className="section bg-secondary">
                    <Container className="pb-5">
                        <Row className="row-grid">
                            <Col className="text-center">
                                <div className="icon icon-lg icon-shape icon-shape-primary shadow rounded-circle mb-4">
                                    <i className="ni ni-briefcase-24" />
                                </div>
                                <h3 className="display-5">
                                    All Available Positions
                                </h3>
                            </Col>
                        </Row>
                        <hr/>
                        {(jobs.length > 0) ? jobs.map((job, i) => (
                            <Card>
                                <CardBody>
                                    <h5 className="mb-3">{job.title}</h5>
                                    <p>{job.description}</p>
                                    <Button
                                        className="mt-3"
                                        color="primary"
                                        type="button"
                                        href={job.url}
                                        target="_blank"
                                        title={`Apply for ${job.title} position`}
                                        >
                                        Apply
                                    </Button>
                                </CardBody>
                            </Card>
                        )) : (
                            <Row className="row-grid justify-content-center">
                                <Col className="text-center py-4" md="6">
                                    <h5 className="mb-2">
                                        No available positions at this time.
                                    </h5>
                                    <p className="lead">
                                        Please check back later to find more available positions and we appreciate for your interest.
                                    </p>
                                </Col>
                            </Row>
                        )}
                        <hr/>
                    </Container>
                    <div className="separator separator-bottom separator-skew">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                            >
                            <polygon
                                className="fill-white"
                                points="0 0 2560 100 0 100"
                                />
                        </svg>
                    </div>
                </section>
                <section className="section">
                    <Container>
                        <Row className="row-grid justify-content-center text-center">
                            <Col md="6">
                                <h3 className="display-4">
                                    Not finding the job you want?
                                </h3>
                                <p className="lead mb-5">
                                    Get on our jobs mailing list and we will email you whenever a new position opens up.
                                </p>
                                {formSubmitted ? (
                                    <Alert color="success" className="mb-0">
                                        Thank you for contacting Club Apps about a potential job opportunity. As positions open up that fit your interest, we will reach out to you via email with a link to apply.
                                    </Alert>
                                ) : (
                                    <Form id="agile-form">
                                        <FormGroup row className="text-left align-items-center">
                                            <Label for="sales-input-first" lg={3}>First Name</Label>
                                            <Col lg={9}>
                                                <Input
                                                    type="text"
                                                    name="first"
                                                    id="jobs-input-first"
                                                    placeholder="John"
                                                    value={form.first}
                                                    onChange={handleChange('first')}
                                                    className={isError('first') ? 'is-invalid' : ''}
                                                    disabled={loading}
                                                />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row className="text-left align-items-center">
                                            <Label for="sales-input-last" lg={3}>Last Name</Label>
                                            <Col lg={9}>
                                                <Input
                                                    type="text"
                                                    name="last"
                                                    id="jobs-input-last"
                                                    placeholder="Snow"
                                                    value={form.last}
                                                    onChange={handleChange('last')}
                                                    className={isError('last') ? 'is-invalid' : ''}
                                                    disabled={loading}
                                                />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row className="text-left align-items-center">
                                            <Label for="sales-input-email" lg={3}>Email</Label>
                                            <Col lg={9}>
                                                <Input
                                                    type="email"
                                                    name="email"
                                                    id="jobs-input-email"
                                                    placeholder="john.snow@stark.org"
                                                    value={form.email}
                                                    onChange={handleChange('email')}
                                                    className={isError('email') ? 'is-invalid' : ''}
                                                    disabled={loading}
                                                />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row className="text-left align-items-center">
                                            <Label for="sales-input-email" lg={3}>What are you looking for?</Label>
                                            <Col lg={9}>
                                                <Input
                                                    type="text"
                                                    name="interest"
                                                    id="jobs-input-interest"
                                                    placeholder="To Slay whitewalkers"
                                                    value={form.interest}
                                                    onChange={handleChange('interest')}
                                                    className={isError('interest') ? 'is-invalid' : ''}
                                                    disabled={loading}
                                                />
                                            </Col>
                                        </FormGroup>
                                        <Row>
                                            <Col>
                                                <Button
                                                    className="mt-3 mb-3"
                                                    color="success"
                                                    type="button"
                                                    onClick={postForm}
                                                    disabled={loading}
                                                    >
                                                    Connect
                                                </Button>
                                            </Col>
                                        </Row>
                                        {(errorMessage) &&
                                            <Alert color="danger" className="mt-4">
                                                <strong>Warning!</strong> {errorMessage} 
                                            </Alert>
                                        }
                                    </Form>
                                )}
                            </Col>
                        </Row>
                        <Row className="row-grid justify-content-center">
                            <Col md="6">
                                <div className="d-flex px-3">
                                    <div>
                                        <div className="icon icon-lg icon-shape bg-white shadow rounded-circle">
                                            <i className="ni ni-email-83 text-success" />
                                        </div>
                                    </div>
                                    <div className="pl-4">
                                        <h4 className="text-success">Send us an Email</h4>
                                        <p className="mt-2">
                                            Would you prefer to email us directly? Reach us at&nbsp;
                                            <a href="mailto:jobs@clubapps.org">jobs@clubapps.org</a>.
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </main>
            <SimpleFooter/>
        </Fragment>
    )
}
